import { ConfigProviderProps, ThemeConfig } from "antd";
import tailwindColors from "tailwindcss/colors";
import { ComponentStyleConfig } from "antd/lib/config-provider/context";
import type { ConditionalPick } from "type-fest";

import colors from "./colors";

export const antdTheme: ThemeConfig = {
  components: {
    Button: {
      colorPrimary: colors.magenta["500"],
      colorPrimaryHover: colors.magenta["400"],
      colorPrimaryActive: colors.magenta["600"],
      primaryShadow: `0 2px 0 ${colors.magenta["50"]}`,
    },
    Menu: {
      itemMarginInline: 0,
      marginXXS: 0,
      padding: 22,
      paddingXL: 0,
      collapsedWidth: 64,
    },
    Form: {
      colorTextDescription: "black",
      lineWidth: 0,
    },
    Notification: {
      marginXS: 0,
      colorErrorBg: colors.red["50"],
      colorInfoBg: colors.blue["50"],
      colorSuccessBg: colors.green["50"],
      colorWarningBg: colors.amber["50"],
    },
    Collapse: {
      colorBgContainer: tailwindColors.white,
      colorFillAlter: tailwindColors.white,
    },
    Cascader: {
      dropdownHeight: 330,
    },
    Table: {
      rowSelectedHoverBg: colors.aqua[50],
    },
  },
  token: {
    colorPrimary: colors.aqua["600"],
    colorLink: colors.aqua["600"],
    colorLinkHover: colors.magenta["500"],
    borderRadius: 0,
    fontFamily: "inherit",
    colorError: colors.red["500"],
    controlItemBgActive: colors.aqua["50"],
  },
};

export const antdComponentConfig: Partial<
  ConditionalPick<Required<ConfigProviderProps>, ComponentStyleConfig>
> = {
  form: { colon: false },
  modal: {
    mask: {
      blur: false,
    },
  },
  drawer: {
    mask: {
      blur: false,
    },
  },
};
